<app-header></app-header>
<!-- Start of Desktop Content -->
<ion-content
  *ngIf="(platformService?.isTouchExperience$ | async) === false"
  class="gray-content-bg"
  scroll-y="false"
  id="menu-context"
>
  <ion-grid [class.hide]="isSelectedListLoaded$ | async" [fixed]="true">
    <app-list-skeleton></app-list-skeleton>
  </ion-grid>
  <div [class.hide]="(isSelectedListLoaded$ | async) === false" id="desktop">
    <cdk-virtual-scroll-viewport
      id="list-scroll-{{vm?.list?.listKey?.listId}}"
      data-cy="list-detail-desktop-scroll"
      class="cdk-scroll"
      orientation="vertical"
      appCustomVs
      [itemHeights]="vm?.itemHeights"
      [indexOffset]="2"
      [items]="vm?.items"
      [listId]="vm?.list?.listKey?.listId"
    >
      <ion-grid [fixed]="true">
        <!-- Breadcrumbs -->
        <ion-row class="breadcrumbs-section">
          <ion-col size="8">
            <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
          </ion-col>
          <ion-col *ngIf="vm?.list?.listItemCount > 0" size="4">
            <ion-row class="interact-download">
              <ion-label (click)="openDownloadPrintModal(false)">
                <ion-icon name="print-outline"></ion-icon>
                {{ 'i18n.common.print' | translate }}
              </ion-label>
              <ion-label (click)="openDownloadPrintModal(true)">
                <ion-icon name="download-outline"></ion-icon>
                {{ 'i18n.common.download' | translate }}
              </ion-label>
            </ion-row>
          </ion-col>
        </ion-row>
        <!-- List Banner -->
        <app-list-banner
          [listName]="vm?.list?.listKey?.listTypeId === ListTypes.og ? 'Order Guide #' + vm?.list?.listKey?.listId : vm?.list?.listName"
          [listItemCount]="vm?.list?.listItemCount"
          [showEllipsis]="(vm?.showEllipsis || (copyListEnabled && vm?.list?.listItemCount > 0)) && !vm?.pmeListFeatureFlag"
          (ellipsisClickEventEmitter)="openListOptions($event)"
        ></app-list-banner>
        <ion-row
          [class.hide]="vm?.importErrors === undefined || vm?.importErrors.errors.length === 0"
        >
          <app-import-error-toast
            class="import-error-toast"
            [platform]="platformService?.platformType"
            (dismissEvent)="removeImportErrors(vm?.list?.listKey)"
            (openModalEvent)="openImportListErrorModal()"
          >
          </app-import-error-toast>
        </ion-row>

        <ion-row
          class="ion-margin-top"
          [class.hide]="vm?.list?.listItemCount === 0"
        >
          <ion-col size-xl="9" size-lg="8" size-md="8">
            <ng-container
              [ngTemplateOutlet]="searchSortFilter"
              [ngTemplateOutletContext]="{ pmeListFeatureFlag: vm?.pmeListFeatureFlag }"
            ></ng-container>
          </ion-col>
          <ion-col
            *ngIf="vm?.pmeListFeatureFlag"
            offset-xl="0.25"
            offset-lg="0.5"
            offset-md="0.15"
            size-xl="2.15"
            size-lg="2.75"
            size-md="3.1"
          >
            <ng-container
              [ngTemplateOutlet]="pmeToggle"
              [ngTemplateOutletContext]="{ listViewMode: vm?.selectedListViewModel?.selectedListViewMode }"
            ></ng-container>
          </ion-col>
          <ion-col
            *ngIf="vm?.pmeListFeatureFlag"
            offset="0.35"
            size-xl="0.25"
            size-lg="0.4"
            size-md="0.4"
          >
            <ng-container [ngTemplateOutlet]="newEllipsis"></ng-container>
          </ion-col>
        </ion-row>
        <!-- desktop -->
        <ion-row *ngIf="vm?.pmeListFeatureFlag" class="ion-margin-top">
          <ion-col size-xl="9" size-lg="8" size-md="8" size-sm="9" size-xs="9">
            <div class="sort-filter-buttons-container">
              <app-sort-and-filter-button
                [sortAndFilterCount]="vm?.sortAndFilterCount"
                (openSortAndFilterListModalEmitter)="handleOpenSortAndFilterListModal(vm?.selectedListViewModel?.selectedListViewMode)"
                (clearSortAndFilterListModalEmitter)="handleClearSortAndFilterListModalEmitter(vm?.selectedListViewModel?.selectedListViewMode)"
              ></app-sort-and-filter-button>
              <app-pme-list-filter-buttons
                *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
                [platformType]="platformService?.platformType"
                [filters]="vm?.pmeSearchSortFilterOptions?.filters || []"
                (filtersChange)="handleFiltersChange($event)"
              ></app-pme-list-filter-buttons>
            </div>
          </ion-col>

          <!-- PME Friday Toggle Desktop -->
          <ion-col
            *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing && isFriday$ | async"
            class="pme-toggle-column-desktop"
          >
            <app-usf-pme-toggle
              [fridayDate]="fridayDate"
              [saturdayDate]="saturdayDate"
              [toggleIsOn]="vm?.selectedListViewModel?.fridayToggleOn"
              [toggleIsDisabled]="clientListViewService.isAnyEasyPricingProcessingForSelectedList$ | async"
              (toggleChange)="handleFridayToggleChange($event)"
            ></app-usf-pme-toggle>
          </ion-col>
        </ion-row>

        <ion-row class="main-content">
          <!-- No Results -->
          <ion-col
            [class.hide]="vm?.items?.length !== 0"
            size-xl="9"
            size-lg="8"
            size-md="8"
            size-sm="9"
            size-xs="9"
          >
            <app-no-products-in-group
              [listCount]="vm?.list?.listItemCount"
              [itemsLeftAfterFilter]="vm?.items?.length"
              [isEditableList]="vm?.list?.listKey?.listTypeId !== 'OG'"
              [isMobile]="false"
              [isListManagement]="false"
              (addProductActionEmitter)="onAddProductAction()"
            ></app-no-products-in-group>
          </ion-col>
          <!-- List of groups and products -->
          <ion-col
            [class.hide]="vm?.items?.length === 0"
            size-xl="9"
            size-lg="8"
            size-md="8"
            size-sm="9"
            size-xs="9"
          >
            <app-group-product-list-desktop
              [items]="vm?.items"
              [mode]="mode"
              [list]="vm?.list"
              [pricingDisabled]="vm?.selectedCustomer?.ogPrintPriceInd === 'N'"
              [isOnline]="(panAppState.online$ | async)"
              [showNotes]="vm?.list?.listKey?.listTypeId !== ListTypes.og"
              [listItemNoteFeatureFlag]="vm?.listItemNoteFeatureFlag"
              [listViewMode]="vm?.selectedListViewModel?.selectedListViewMode"
              [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
              [selectedListType]="vm?.selectedListViewModel?.selectedListType"
              [screenWidth]="vm?.platform?.width"
              [selectedListItemKey]="vm?.selectedListViewModel?.selectedListItemKey"
              (ellipsisEmitter)="openProductCardEllipsis($event)"
              (infoIconClickEmitter)="openProductStatus($event)"
              (itemNoteClickEmitter)="openItemNotes($event)"
              (productCardClickEmitter)="routeToPDP($event)"
              (promotionClickEmitter)="clickPromotions($event)"
              (quantityInputEmitter)="quantityFocusHandler($event)"
              (quantityUpdateEmitter)="changeQuantityHandler($event)"
              (betterBuyDeclineEmitter)="handleBetterBuyDeclineClick($event)"
              (acceptSwapEmitter)="acceptSwap($event)"
              (productConversionEmitter)="handleProductConversionClick($event)"
              (priceChanged)="emitPriceChanged($event)"
              (PMEProductCardClickEmitter)="handlePmeProductClick($event)"
              (closeManualApproval)="handleCloseManualApproval($event)"
            >
            </app-group-product-list-desktop>
          </ion-col>
          <ion-col
            offset-xl="0.25"
            offset-lg="0.5"
            offset-md="0.1"
            size-xl="2.75"
            size-lg="3.5"
            size-md="3.9"
          >
            <app-order-info-sidebar
              *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.ordering"
              [platform]="platformService?.platformType"
              [orderHeader]="vm?.orderHeader"
              [orderItemTallies]="vm?.orderItemTallies"
              [isList]="true"
              [isCart]="false"
              [isOnMinimumOrderMetFlag]="vm?.orderMinimumMetFeatureFlag"
              [showPrintIcon]="false"
            >
            </app-order-info-sidebar>
          </ion-col>
        </ion-row>
      </ion-grid>
      <div id="footer">
        <app-footer></app-footer>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <!-- Price Mode Sidebar -->
  <div
    #priceModeSidebar
    class="desktop-sidebar"
    *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
  >
    <ion-grid
      [class.hide]="(isSelectedListLoaded$ | async) === false"
      [fixed]="true"
    >
      <ion-row>
        <ion-col
          size-xl="9"
          size-lg="8"
          size-md="8"
          size-sm="9"
          size-xs="9"
        ></ion-col>
        <ion-col
          offset-xl="0.25"
          offset-lg="0.5"
          offset-md="0.1"
          size-xl="2.75"
          size-lg="3.5"
          size-md="3.9"
        >
          <!-- Right Rail -->
          <app-pme-right-rail
            *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
            [isMobile]="false"
            [product]="vm?.selectedProduct"
            [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
            (productDetailsClick)="routeToPDP({productNumber: vm?.selectedProduct?.productNumber, isQuickView: false})"
          >
          </app-pme-right-rail>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<!-- Start of Tablet Content -->
<ion-content
  *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
  class="gray-content-bg"
  scroll-y="false"
  id="menu-context"
>
  <ion-grid [class.hide]="isSelectedListLoaded$ | async" [fixed]="true">
    <app-list-skeleton></app-list-skeleton>
  </ion-grid>
  <cdk-virtual-scroll-viewport
    id="list-scroll-{{vm?.list?.listKey?.listId}}"
    [class.hide]="(isSelectedListLoaded$ | async) === false"
    data-cy="list-detail-tablet-scroll"
    class="cdk-scroll"
    orientation="vertical"
    appCustomVs
    [itemHeights]="vm?.itemHeights"
    [indexOffset]="2"
    [items]="vm?.items"
    [listId]="vm?.list?.listKey?.listId"
  >
    <!-- List Banner -->
    <app-list-banner
      [listName]="vm?.list?.listKey?.listTypeId === ListTypes.og ? 'Order Guide #' + vm?.list?.listKey?.listId : vm?.list?.listName"
      [listItemCount]="vm?.list?.listItemCount"
      [showEllipsis]="(vm?.showEllipsis || (copyListEnabled && vm?.list?.listItemCount > 0)) && !vm?.pmeListFeatureFlag"
      (ellipsisClickEventEmitter)="openListOptions($event)"
      (downloadClickEventEmitter)="openDownloadPrintModal(true)"
      (printClickEventEmitter)="openDownloadPrintModal(false)"
    ></app-list-banner>
    <ion-grid [fixed]="true">
      <ion-row
        [class.hide]="vm?.importErrors === undefined || vm?.importErrors.errors.length === 0"
      >
        <app-import-error-toast
          class="import-error-toast"
          [platform]="platformService?.platformType"
          (dismissEvent)="removeImportErrors(vm?.list?.listKey)"
          (openModalEvent)="openImportListErrorModal()"
        >
        </app-import-error-toast>
      </ion-row>

      <ion-row
        class="ion-margin-top"
        [class.hide]="vm?.list?.listItemCount === 0"
      >
        <ion-col
          size-xl="8"
          size-lg="8"
          size-md="7.5"
          size-sm="7.5"
          class="search-sort-container-tablet"
        >
          <ng-container [ngTemplateOutlet]="searchSortFilter"></ng-container>
        </ion-col>
        <ion-col
          *ngIf="vm?.pmeListFeatureFlag"
          offset="0.25"
          size-lg="3"
          size-md="3.25"
          size-sm="3.25"
        >
          <ng-container
            [ngTemplateOutlet]="pmeToggle"
            [ngTemplateOutletContext]="{ listViewMode: vm?.selectedListViewModel?.selectedListViewMode }"
          ></ng-container>
        </ion-col>
        <ion-col
          *ngIf="vm?.pmeListFeatureFlag"
          offset-lg="0.25"
          size-lg="0.5"
          offset-md="0.5"
          size-md="0.5"
          offset-sm="0.5"
          size-sm="0.5"
        >
          <ng-container [ngTemplateOutlet]="newEllipsis"></ng-container>
        </ion-col>
      </ion-row>

      <!-- PME toggle for pricing mode -->
      <!-- PME Friday Toggle Tablet -->
      <ion-row
        *ngIf="vm?.pmeListFeatureFlag && vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
        class="ion-margin-top"
      >
        <!-- tablet -->
        <ion-col
          size-xl="8"
          size-lg="8"
          size-md="7.5"
          size-sm="7.5"
          class="pme-filter-buttons-col"
        >
          <div
            class="sort-filter-buttons-container tablet-filter-buttons-scroll"
          >
            <app-usf-pme-toggle
              [class.hide]="(isFriday$ | async) === false"
              [fridayDate]="fridayDate"
              [saturdayDate]="saturdayDate"
              [toggleIsOn]="vm?.selectedListViewModel?.fridayToggleOn"
              [toggleIsDisabled]="clientListViewService.isAnyEasyPricingProcessingForSelectedList$ | async"
              (toggleChange)="handleFridayToggleChange($event)"
            ></app-usf-pme-toggle>
            <app-pme-list-filter-buttons
              *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
              [platformType]="platformService?.platformType"
              [filters]="vm?.pmeSearchSortFilterOptions?.filters || []"
              (filtersChange)="handleFiltersChange($event)"
            ></app-pme-list-filter-buttons>
          </div>
        </ion-col>
      </ion-row>

      <!-- Main Content-->
      <ion-row class="ion-margin-top">
        <!-- No Results -->
        <ion-col
          [class.hide]="vm?.items?.length !== 0"
          size-xl="8"
          size-lg="8"
          size-md="7.5"
          size-sm="7"
          size-xs="9"
        >
          <app-no-products-in-group
            [listCount]="vm?.list?.listItemCount"
            [itemsLeftAfterFilter]="vm?.items?.length"
            [isEditableList]="vm?.list?.listKey?.listTypeId !== 'OG'"
            [isMobile]="false"
            [isListManagement]="false"
            (addProductActionEmitter)="onAddProductAction()"
          ></app-no-products-in-group>
        </ion-col>
        <!-- List of groups and products -->
        <ion-col
          [class.hide]="vm?.items?.length === 0"
          size-xl="8"
          size-lg="8"
          size-md="7.5"
          size-sm="7.5"
        >
          <app-group-product-list-touch
            [items]="vm?.items"
            [mode]="mode"
            [list]="vm?.list"
            [pricingDisabled]="vm?.selectedCustomer?.ogPrintPriceInd === 'N'"
            [isOnline]="(panAppState.online$ | async)"
            [isMobile]="false"
            [showNotes]="vm?.list?.listKey?.listTypeId !== ListTypes.og"
            [listItemNoteFeatureFlag]="vm?.listItemNoteFeatureFlag"
            [listViewMode]="vm?.selectedListViewModel?.selectedListViewMode"
            [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
            [selectedListType]="vm?.selectedListViewModel?.selectedListType"
            [screenWidth]="vm?.platform?.width"
            [selectedListItemKey]="vm?.selectedListViewModel?.selectedListItemKey"
            (ellipsisEmitter)="openProductCardEllipsis($event)"
            (infoIconClickEmitter)="openProductStatus($event)"
            (itemNoteClickEmitter)="openItemNotes($event)"
            (productCardClickEmitter)="routeToPDP($event)"
            (promotionClickEmitter)="clickPromotions($event)"
            (quantityInputEmitter)="quantityFocusHandler($event)"
            (quantityUpdateEmitter)="changeQuantityHandler($event)"
            (betterBuyDeclineEmitter)="handleBetterBuyDeclineClick($event)"
            (acceptSwapEmitter)="acceptSwap($event)"
            (productConversionEmitter)="handleProductConversionClick($event)"
            (priceChanged)="emitPriceChanged($event)"
            (PMEProductCardClickEmitter)="handlePmeProductClick($event)"
            (closeManualApproval)="handleCloseManualApproval($event)"
          >
          </app-group-product-list-touch>
        </ion-col>
        <ion-col
          size-xl="3.7"
          size-lg="3.7"
          size-md="4.2"
          push-md="0.3"
          push-sm="0.3"
          size-sm="4.2"
        >
          <app-order-info-sidebar
            *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.ordering"
            [platform]="platformService?.platformType"
            [orderHeader]="vm?.orderHeader"
            [orderItemTallies]="vm?.orderItemTallies"
            [isList]="true"
            [isCart]="false"
            [isOnMinimumOrderMetFlag]="vm?.orderMinimumMetFeatureFlag"
            [showPrintIcon]="false"
          ></app-order-info-sidebar>
        </ion-col>
      </ion-row>
    </ion-grid>
  </cdk-virtual-scroll-viewport>

  <!-- Price Mode Sidebar Tablet -->
  <div
    #priceModeSidebar
    class="tablet-sidebar"
    *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
  >
    <ion-grid
      [class.hide]="(isSelectedListLoaded$ | async) === false"
      [fixed]="true"
    >
      <ion-row>
        <ion-col size-xl="8" size-lg="8" size-md="7.5" size-sm="7.5"></ion-col>
        <ion-col
          size-xl="3.7"
          size-lg="3.7"
          size-md="4.2"
          push-md="0.3"
          push-sm="0.3"
          size-sm="4.2"
        >
          <app-pme-right-rail
            *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
            [isMobile]="false"
            [product]="vm?.selectedProduct"
            [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
            (productDetailsClick)="routeToPDP({productNumber: vm?.selectedProduct?.productNumber, isQuickView: false})"
          ></app-pme-right-rail>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<!-- Start of Mobile Content -->
<ion-content
  *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
  class="gray-content-bg"
  scroll-y="false"
>
  <cdk-virtual-scroll-viewport
    data-cy="list-detail-mobile-scroll"
    class="cdk-scroll"
    orientation="vertical"
    appCustomVs
    [itemHeights]="vm?.itemHeights"
    [indexOffset]="2"
    [items]="vm?.items"
    [listId]="vm?.list?.listKey?.listId"
  >
    <app-list-skeleton
      [class.hide]="isSelectedListLoaded$ | async"
    ></app-list-skeleton>

    <ion-grid
      [fixed]="true"
      [class.hide]="(isSelectedListLoaded$ | async) === false"
    >
      <ion-row class="ion-margin-top" *ngIf="vm?.pmeListFeatureFlag">
        <ion-col>
          <ng-container
            [ngTemplateOutlet]="pmeToggle"
            [ngTemplateOutletContext]="{ listViewMode: vm?.selectedListViewModel?.selectedListViewMode }"
          ></ng-container>
        </ion-col>
      </ion-row>
      <!-- List Banner -->
      <app-list-banner
        [listName]="vm?.list?.listKey?.listTypeId === ListTypes.og ? 'Order Guide #' + vm?.list?.listKey?.listId : vm?.list?.listName"
        [listItemCount]="vm?.list?.listItemCount"
        [showEllipsis]="(vm?.showEllipsis || (copyListEnabled && vm?.list?.listItemCount > 0))"
        (ellipsisClickEventEmitter)="openListOptions($event)"
      ></app-list-banner>
      <ion-row
        [class.hide]="vm?.importErrors === undefined || vm?.importErrors.errors.length === 0"
      >
        <app-import-error-toast
          class="import-error-toast"
          [platform]="platformService?.platformType"
          (dismissEvent)="removeImportErrors(vm?.list?.listKey)"
          (openModalEvent)="openImportListErrorModal()"
        >
        </app-import-error-toast>
      </ion-row>
      <!-- Search, Sort & Filter -->
      <ion-row
        class="ion-margin-top"
        [class.hide]="vm?.list?.listItemCount === 0"
      >
        <ion-col size="12">
          <ng-container [ngTemplateOutlet]="searchSortFilter"></ng-container>
        </ion-col>
      </ion-row>

      <!-- PME toggle for pricing mode mobile -->
      <ion-row
        *ngIf="vm?.pmeListFeatureFlag && vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
        class="ion-margin-top"
      >
        <!-- mobile -->
        <ion-col size="12" offset="0">
          <div
            class="sort-filter-buttons-container mobile-pme-list-filter-buttons-scroll"
          >
            <app-usf-pme-toggle
              [class.hide]="(isFriday$ | async) !== true"
              [fridayDate]="fridayDate"
              [saturdayDate]="saturdayDate"
              [toggleIsOn]="vm?.selectedListViewModel?.fridayToggleOn"
              [toggleIsDisabled]="clientListViewService.isAnyEasyPricingProcessingForSelectedList$ | async"
              (toggleChange)="handleFridayToggleChange($event)"
            ></app-usf-pme-toggle>
            <app-pme-list-filter-buttons
              *ngIf="vm?.selectedListViewModel?.selectedListViewMode === ListViewMode.pricing"
              [platformType]="platformService?.platformType"
              [filters]="vm?.pmeSearchSortFilterOptions?.filters || []"
              (filtersChange)="handleFiltersChange($event)"
            ></app-pme-list-filter-buttons>
          </div>
        </ion-col>
      </ion-row>

      <!-- Filter Buttons -->
      <ion-row>
        <ion-col size="12"> </ion-col>
      </ion-row>

      <!-- List of groups and products -->
      <app-group-product-list-touch
        [items]="vm?.items"
        [mode]="mode"
        [list]="vm?.list"
        [pricingDisabled]="vm?.selectedCustomer?.ogPrintPriceInd === 'N'"
        [isOnline]="(panAppState.online$ | async)"
        [isMobile]="true"
        [showNotes]="vm?.list?.listKey?.listTypeId !== ListTypes.og"
        [listItemNoteFeatureFlag]="vm?.listItemNoteFeatureFlag"
        [listViewMode]="vm?.selectedListViewModel?.selectedListViewMode"
        [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
        [selectedListType]="vm?.selectedListViewModel?.selectedListType"
        [screenWidth]="vm?.platform?.width"
        [selectedListItemKey]="vm?.selectedListViewModel?.selectedListItemKey"
        (ellipsisEmitter)="openProductCardEllipsis($event)"
        (infoIconClickEmitter)="openProductStatus($event)"
        (itemNoteClickEmitter)="openItemNotes($event)"
        (productCardClickEmitter)="routeToPDP($event)"
        (promotionClickEmitter)="clickPromotions($event)"
        (quantityInputEmitter)="quantityFocusHandler($event)"
        (quantityUpdateEmitter)="changeQuantityHandler($event)"
        (betterBuyDeclineEmitter)="handleBetterBuyDeclineClick($event)"
        (acceptSwapEmitter)="acceptSwap($event)"
        (productConversionEmitter)="handleProductConversionClick($event)"
        (priceChanged)="emitPriceChanged($event)"
        (PMEProductCardClickEmitter)="handlePmeProductClick($event)"
        (closeManualApproval)="handleCloseManualApproval($event)"
      >
      </app-group-product-list-touch>
      <!-- No Results -->
      <ion-row *ngIf="vm?.items?.length === 0">
        <ion-col size="12">
          <app-no-products-in-group
            [listCount]="vm?.list?.listItemCount"
            [itemsLeftAfterFilter]="vm?.items?.length"
            [isEditableList]="vm?.list?.listKey?.listTypeId !== 'OG'"
            [isMobile]="true"
            [isListManagement]="false"
            (addProductActionEmitter)="onAddProductAction()"
          ></app-no-products-in-group>
        </ion-col>
      </ion-row>
    </ion-grid>
  </cdk-virtual-scroll-viewport>
</ion-content>

<div
  [class.static-buttons]="platformService.platformType === platformService.platformEnum.mobile && showTopButton"
  data-cy="list-detail-static-buttons-section"
>
  <div
    *ngIf="platformService.platformType === platformService.platformEnum.mobile && vm?.orderItemTallies?.totalItems > 0"
    data-cy="list-detail-review-order-button-section"
    class="review-order-mobile"
  >
    <ion-button
      data-cy="list-detail-review-order-button"
      class="usf-fill-green-mobile-modal-button"
      (click)="routeTo('/order')"
    >
      {{ 'i18n.lists.reviewOrder' | translate }}
    </ion-button>
  </div>
  <div
    *ngIf="showTopButton"
    data-cy="list-detail-top-button-section"
    class="top-button"
  >
    <ion-button
      data-cy="list-detail-top-button"
      class="usf-fill-green-button"
      (click)="goToTop()"
    >
      {{ 'i18n.common.top' | translate }}&nbsp;
      <ion-icon
        data-cy="list-detail-top-button-icon"
        name="chevron-up-circle-outline"
      ></ion-icon>
    </ion-button>
  </div>
</div>

<!-- SEARCH, SORT & FILTER TEMPLATE -->
<ng-template #searchSortFilter let-pmeListFeatureFlag="pmeListFeatureFlag">
  <div
    data-cy="list-detail-search-sort-filter-section"
    class="search-sort-filter-section"
  >
    <div class="search-container">
      <ion-searchbar
        id="list-search-bar-{{vm?.list?.listKey?.listId}}-0"
        data-cy="list-detail-searchbar"
        class="search"
        globalkeyhandler="filterBar"
        mode="md"
        placeholder="{{ 'i18n.lists.searchWithinYourList' | translate }}"
        [(ngModel)]="searchKey"
        (ionInput)="search()"
        (ionClear)="resetSearch()"
        (search)="search()"
        (ionFocus)="selectFirstProductForPricing()"
      >
      </ion-searchbar>
    </div>
    <app-sort-and-filter-button
      *ngIf="!pmeListFeatureFlag || platformService?.platformType !== platformService?.platformEnum?.desktop"
      [sortAndFilterCount]="vm?.sortAndFilterCount"
      [showClearAll]="platformService?.platformType === platformService?.platformEnum?.desktop"
      (openSortAndFilterListModalEmitter)="handleOpenSortAndFilterListModal(vm?.selectedListViewModel?.selectedListViewMode)"
      (clearSortAndFilterListModalEmitter)="handleClearSortAndFilterListModalEmitter(vm?.selectedListViewModel?.selectedListViewMode)"
    ></app-sort-and-filter-button>
  </div>
</ng-template>

<ng-template #pmeToggle>
  <ion-segment
    data-cy="list-detail-pme-toggle"
    class="pme-toggle"
    mode="ios"
    value="{{ vm?.selectedListViewModel?.selectedListViewMode }}"
    (ionChange)="handleListViewModeChange($event)"
  >
    <!-- PME Toggle -->
    <ion-segment-button
      data-cy="list-view-mode-ordering-toggle-button"
      value="{{ ListViewMode.ordering }}"
    >
      <ion-label data-cy="list-view-mode-ordering-toggle-text">
        {{ 'i18n.common.order' | translate }}
      </ion-label>
    </ion-segment-button>
    <ion-segment-button
      data-cy="list-view-mode-pricing-toggle-button"
      value="{{ ListViewMode.pricing }}"
    >
      <ion-label data-cy="list-view-mode-pricing-toggle-text">
        {{ 'i18n.productDetail.sellerDetail.pricing' | translate }}
      </ion-label>
    </ion-segment-button>
  </ion-segment>
</ng-template>

<!-- New Ellipsis -->
<ng-template #newEllipsis>
  <div data-cy="ellipsis-container">
    <ion-icon
      class="ellipsis-icon"
      data-cy="ellipsis-icon"
      name="ellipsis-vertical"
      (click)="openListOptions($event)"
    ></ion-icon>
  </div>
</ng-template>

<!-- Download List Modal -->
<app-list-download-container
  [translateService]="translateService"
  (submitEvent)="downloadList($event)"
></app-list-download-container>
<!-- Download list modal-->
<app-list-print-container
  [translateService]="translateService"
  (submitEvent)="downloadList($event)"
></app-list-print-container>
<ion-modal
  [isOpen]="listsOverlayService?.listDownloadModalOptions$?.value?.isOpen"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  (ionModalDidDismiss)="closeDownloadListModal()"
  [ngClass]="platformService.platformType !== platformService.platformEnum.desktop ? 'ion-modal-touch' : (listsOverlayService?.listDownloadModalOptions$?.value?.isDownload ? 'modal-desktop-size-lg' : 'download-print-desktop')"
>
  <ng-template>
    <app-download-list-v2
      class="ion-page"
      [platformType]="platformService?.platformType"
      [listName]="listsOverlayService?.listDownloadModalOptions$?.value?.listName"
      [listId]="listsOverlayService?.listDownloadModalOptions$?.value?.listId"
      [listTypeId]="listsOverlayService?.listDownloadModalOptions$?.value?.listTypeId"
      [isDownload]="listsOverlayService?.listDownloadModalOptions$?.value?.isDownload"
      [hidePricingOption]="vm?.selectedCustomer?.ogPrintPriceInd === 'N'"
      (dismissEvent)="closeDownloadListModal()"
      (downloadEmitter)="downloadList($event)"
    >
    </app-download-list-v2>
  </ng-template>
</ion-modal>

<!-- Import list Errors Modal-->
<ion-modal
  [isOpen]="listsOverlayService?.listImportErrorsModal$?.value"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  (ionModalDidDismiss)="closeImportListErrorModal()"
  [ngClass]="platformService.platformType !== platformService.platformEnum.desktop ? 'ion-modal-touch' :'import-list-errors-modal-desktop'"
>
  <ng-template>
    <app-import-error-modal
      class="ion-page"
      [platform]="platformService?.platformType"
      [importErrors]="vm?.importErrors?.errors"
      (dismissEvent)="closeImportListErrorModal()"
      (downloadErrorsEvent)="downloadImportErrors()"
    >
    </app-import-error-modal>
  </ng-template>
</ion-modal>

<ion-menu
  menuId="right-rail-menu-{{vm?.list?.listKey?.listId}}"
  side="end"
  contentId="menu-context"
  [swipeGesture]="false"
  class="ion-modal-touch"
>
  <ion-content>
    <app-pme-right-rail
      class="ion-page"
      [isMobile]="true"
      [product]="vm?.selectedProduct"
      [hideLowLimit]="vm?.pmeLowLimitFeatureFlag"
      (closeSidebar)="handleClosePmeMenu()"
      (productDetailsClick)="routeToPDPAndClosePmeModal(vm?.selectedProduct?.productNumber)"
      (priceChanged)="emitPriceChanged($event)"
      (closeManualApproval)="handleCloseManualApproval($event)"
    ></app-pme-right-rail>
  </ion-content>
</ion-menu>

<app-mass-delete-dual-pane-container></app-mass-delete-dual-pane-container>

<ion-menu
  side="start"
  menuId="list-detail-pme-menu-{{vm?.list?.listKey?.listId}}"
  contentId="menu-context"
  [swipeGesture]="false"
>
  <app-pme-sort-filter
    class="ion-page"
    [sortFilterOptions]="vm?.pmeSearchSortFilterOptions"
    [platformType]="platformService?.platformType"
    [isRecentlyPurchased]="false"
    (closeEmitter)="closeSortFilterMenu()"
    (saveEmitter)="savePmeSortAndFilter($event)"
  ></app-pme-sort-filter>
</ion-menu>
